// Font Variable Tester Component
// Temporary tool for adjusting variable font axes

export default function fontTester() {
  return {
    vert: 50,
    rond: 50,
    hght: 50,

    get fontVariationSettings() {
      return `"VERT" ${this.vert}, "ROND" ${this.rond}, "HGHT" ${this.hght}`;
    },

    copySettings() {
      const cssRule = `font-variation-settings: "${this.fontVariationSettings}";`;
      navigator.clipboard.writeText(cssRule);
      console.log('Copied to clipboard:', cssRule);
      alert('CSS copied to clipboard!');
    }
  }
}
